import { Company_vatSystem } from "../../../../types/types/indexTypes";
import { i18n } from "../../i18n";

export { Company_vatSystem as CompanyVatSystem } from "../../../../types/types/indexTypes";

/**
 * Get the VAT system label from the VAT system code
 * @param vatSystem 
 * @returns 
 */
export function getVATSystem(vatSystem: string): string {
    const { t } = i18n.global;
    switch (vatSystem) {
        case Company_vatSystem.NotSubjectTo:
            return t("settings." + Company_vatSystem.NotSubjectTo);
        case Company_vatSystem.BelowTheThreshold:
            return t("settings." + Company_vatSystem.BelowTheThreshold);
        case Company_vatSystem.Normal:
            return t("settings." + Company_vatSystem.Normal);
        case Company_vatSystem.Quartely:
            return t("settings." + Company_vatSystem.Quartely);
        case Company_vatSystem.Simplified:
            return t("settings." + Company_vatSystem.Simplified);
        case Company_vatSystem.SimplifiedExercise:
            return t("settings." + Company_vatSystem.SimplifiedExercise);
        case Company_vatSystem.FlatRateRefund:
            return t("settings." + Company_vatSystem.FlatRateRefund);
        default:
            return t("settings.noVatSystem"); // Added a fallback to avoid errors
    }
}

/**
 * Check if the company is not subject to VAT
 *
 * @export
 * @param {string} vatSystem
 * @return {*}  {boolean}
 */
export function isNotSubjectToVAT(vatSystem: string): boolean {
    return (
        vatSystem === Company_vatSystem.NotSubjectTo ||
        vatSystem === Company_vatSystem.BelowTheThreshold
    );
}
